/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import { TextField } from "@material-ui/core";
import { TIMEZONES } from "../../utility/timeHelpers";
import Autocomplete from "@material-ui/lab/Autocomplete";

/**
 * Autocomplete picker for timezone
 * @param {Object} params
 * - timezone: name of the currently selected timezone
 * - setTimezone: function to set new timezone
 */
const TimezonePicker = ({ timezone, setTimezone }) => {
	const [inputValue, setInputValue] = React.useState("");

	return (
		<Autocomplete
			value={timezone}
			onChange={(event, newValue) => {
				setTimezone(newValue);
			}}
			inputValue={inputValue}
			onInputChange={(event, newInputValue) => {
				setInputValue(newInputValue);
			}}
			options={TIMEZONES}
			style={{ width: 330 }}
			renderInput={(params) => <TextField {...params} label="Time zone" />}
		/>
	);
};

export default TimezonePicker;
